class Resources extends ViewBasic {
    constructor(options) {
        super(options);

    }

    init() {

        this.$moduleList = this.$('.module-files-extranet');
        this.$categories = this.$('.documents-menu-items');
        this.$selectCategory = this.$('#documents-menu');

        this.clickedCategoryIndex;

        this.skin = new Me.skin(this.$('.documents-menu-mobile'));

        this.addEvents();
    }

    addEvents() {
        this.$categories.on('click', (e) => this.clickHandler(e));
        this.$('#documents-menu').on('change', e => this.selectHandler(e));
    }

    removeEvents() {
        this.$categories.off('click', (e) => this.clickHandler(e));
        this.$('#documents-menu').off('change', e => this.selectHandler(e));
    }

    clickHandler(e) {
        e.preventDefault();
        this.clickedCategoryIndex = $(e.currentTarget).index();
        this.$selectCategory.val(this.clickedCategoryIndex).change();
        this.showSelectedCategory();
    }

    selectHandler(e) {
        e.preventDefault();
        this.clickedCategoryIndex = $(e.currentTarget).find(':selected').index();
        this.showSelectedCategory();
    }

    showSelectedCategory() {
        let scope = this;
        this.$categories.each(function (index) {
            $(this).removeClass('active');

            if(scope.clickedCategoryIndex ==  index){
                $(this).addClass('active');
            }
        });
        this.$moduleList.each(function (index) {
            $(this).removeClass('show');

            if(scope.clickedCategoryIndex == index){
                $(this).addClass('show');
            }
        });
    }
}